import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Container, Grid, Box, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LINKS } from "../constants/settings";
import logo from "../assets/images/connectai_logo_branca.png";

interface NonAuthLayoutWrapperProps {
  children: React.ReactNode;
  headerContent?: React.ReactNode;
}

const NonAuthLayoutWrapper: React.FC<NonAuthLayoutWrapperProps> = ({
  children,
  headerContent,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: `
          radial-gradient(circle at top right, #7956F7 0%, transparent 60%) no-repeat,
          radial-gradient(circle at bottom left, #7956F7 0%, transparent 60%) no-repeat,
          linear-gradient(145deg, #36276F, #4C3699 50%, #36276F)
        `,
        backgroundSize: "100% 100%",
        position: "relative",
      }}
    >
      <Container maxWidth="xl" disableGutters sx={{ p: 0 }}>
        <Grid container sx={{ width: "100%" }}>
          {/* Coluna do logo / Boas-vindas */}
          <Grid
            size={{ xs: 12, md: 5 }}
            sx={{
              display: { xs: "none", md: "flex" },
              flexDirection: "column",
              justifyContent: "center",
              px: { xs: 2, md: 4 },
              py: { xs: 2, md: 4 },
            }}
          >
            {headerContent || (
              <Box>
                {/* Logo */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    pl: { xs: 1, sm: 2, md: 5 },
                  }}
                >
                  <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    sx={{
                      height: {
                        xs: "8em",
                        sm: "12em",
                        md: "16em",
                        lg: "20em",
                        xl: "24em",
                      },
                      mb: {
                        xs: "0.3em",
                        sm: "0.4em",
                        md: "0.6em",
                        lg: "0.8em",
                        xl: "1em",
                      },
                    }}
                  />
                </Box>
                {/* Texto de boas-vindas */}
                <Box sx={{ pl: { xs: 2, sm: 3, md: 5 } }}>
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: {
                        xs: "0.8em",
                        sm: "0.9em",
                        md: "1em",
                        lg: "1.1em",
                        xl: "1.2em",
                      },
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      mb: { xs: "0.4em", sm: "0.6em", md: "0.8em", lg: "1em" },
                    }}
                  >
                    <Box component="span" sx={{ color: "#92EF8F" }}>
                      {t("hello")}
                    </Box>
                    {t("greeting")} <br />
                    {t("registerOrLogin")}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.75em",
                        sm: "0.875em",
                        md: "1em",
                        lg: "1.25em",
                      },
                      color: "#FFFFFF",
                    }}
                  ></Typography>
                </Box>
              </Box>
            )}
          </Grid>

          {/* Coluna do conteúdo (formulários) */}
          <Grid
            size={{ xs: 12, md: 7 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: { xs: 2, md: 4 },
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "90%", md: "80%", lg: "60%" },
                background: "#FFFFFF",
                borderRadius: "1em",
                boxShadow: "0 0.25em 0.5em rgba(0,0,0,0.1)",
                my: { xs: "1.25em", md: "1.25em" },
                p: { xs: "0.5em", sm: "1em", md: "1.5em" },
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>

        {/* Footer */}
        <Box
          component="footer"
          sx={{
            width: "100%",
            py: "1rem",
            textAlign: "center",
            position: { xs: "fixed", md: "absolute" },
            bottom: 0,
            left: 0,
            background: "transparent",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: "0.75rem", md: "0.875rem" },
            }}
          >
            <Link
              component={RouterLink}
              to={LINKS.COMPANY_WEBSITE}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "white",
                textDecoration: "none",
                "&:hover": {
                  color: "#93F090",
                },
              }}
            >
              © It Tech
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default NonAuthLayoutWrapper;
